import React from "react";
import Drawer from "@mui/material/Drawer";
import classes from "./style.module.scss";
import ActivityFeeds from "../activity-feed/ActivityFeeds";

const TeamActivityDrawer = ({ open, onClose }) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ className: classes["drawer-paper"] }}
    >
      <div className={classes["drawer-container"]}>
        <div className={classes["drawer-head"]}>
          <div className={classes["drawer-head-icon"]}>
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
          </div>
          <div className={classes["drawer-head-text"]}>
            <p className={classes["drawer-title"]}>Team activity</p>
            <p className={classes["drawer-subtitle"]}>
              What your team thinks about providers
            </p>
          </div>
          <button
            className={classes["drawer-close"]}
            onClick={onClose}
            aria-label="Close"
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <div className={classes["drawer-body"]}>
          <ActivityFeeds />
        </div>
      </div>
    </Drawer>
  );
};

export default TeamActivityDrawer;